import React, { useContext } from 'react';

import { GroupContext } from '../PileCtxProvider';
import GroupMenuCell from './components/GroupMenuCell';
import { CellContainer, Container, Title } from './styles';

const GroupMenu: React.FC = () => {
  const groupData = useContext(GroupContext)?.groupData ?? [];

  return (
    <Container>
      <Title>群組列表</Title>
      <CellContainer>
        {groupData
          .sort((a, b) => {
            if (typeof a.order === 'number' && typeof b.order === 'number') {
              return a.order - b.order;
            } else if (typeof a.order === 'number') {
              return -1;
            }
            return 1;
          })
          .map((g) => {
            return <GroupMenuCell key={g._id} group={g} />;
          })}
      </CellContainer>
    </Container>
  );
};

export default GroupMenu;
